module.exports = __webpack_public_path__ + "img/graphic-2.d0c07507.png";